import { render, staticRenderFns } from "./CommonBenefieciaryShareHolder.vue?vue&type=template&id=49c30a8f&"
import script from "./CommonBenefieciaryShareHolder.vue?vue&type=script&lang=js&"
export * from "./CommonBenefieciaryShareHolder.vue?vue&type=script&lang=js&"
import style0 from "./CommonBenefieciaryShareHolder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports